/*
 * @Descripttion:
 * @version:
 * @Author: lubaicen
 * @Date: 2020-11-04 13:45:14
 * @LastEditors: lubaicen
 * @LastEditTime: 2020-11-11 17:34:13
 */
import MyTable from './table';
import MyBreadcrumb from './breadcrumb';
import MyArea from './area';
import MyMenu from './menu';
import MyFooterBtn from './footerBtn';
import MyTableBtn from './tableBtn';
import MySeachOption from './seachOption';
import MyHeadTitle from './headTitle';
import MyInfoItem from './infoItrm';
import MyFormItem from './formItem';
// import MyIconImg from './iconImg';
import MyImgList from './imgList';
import MyOrganizeTree from './organizeTree';
import MyMap from './map';
import MyRadioGroup from './radioGroup';
import MySelect from './select';
import MyCheckboxGroup from './checkboxGroup';
import MyLeftMenu from './leftMenu';
import MyTableDot from './tableDot';
import MyTableTag from './tableTag';
import loading from './loading'; // 加载组件
import message from './message'; // 提示组件
import realTimeAlarm from './realTimeAlarm'; // 告警弹窗组件
import showModal from './showModal'; // 弹窗组件
import video from './video'; // 视频组件
import UxModalJs from './uxModal'; // uxModal  原来的没有i18n重新覆盖
import MoreDropdown from './moreDropdown'; // 更多选项下拉框
import Card from "./Card"

const components = [
  MyTable,
  MyBreadcrumb,
  MyArea,
  MyMenu,
  MyFooterBtn,
  MyTableBtn,
  MySeachOption,
  MyHeadTitle,
  MyInfoItem,
  MyFormItem,
  // MyIconImg,
  MyImgList,
  MyOrganizeTree,
  MyMap,
  MyRadioGroup,
  MySelect,
  MyCheckboxGroup,
  MyLeftMenu,
  MyTableDot,
  MyTableTag,
  MoreDropdown
];

const install = function(Vue) {
  components.forEach(component => {
    Vue.component(component.name, component);
  });

  Vue.use(loading);
  Vue.use(message);
  Vue.use(realTimeAlarm);
  Vue.use(showModal);
  Vue.use(video);
  Vue.use(UxModalJs);
  Vue.use(Card);
};

export default {
  install
};
